export const FLUSH_SIDES = ["left", "right"]

export const LEFT_TRIP_LEVER_TAG = "Left-Hand Trip Lever"

export const RIGHT_TRIP_LEVER_TAG = "Right-Hand Trip Lever"

export const TRIP_TAG = "Trip Lever"

export const DEFAULT_SKU = "20120-L-SN-ChromeDefault"

export const FLUSH_HANDLE_PLACEMENT = "Flush Handle Placement"
